import instance, { BASE_URL } from "../../services/api";

const ShiftApiViewController = () => {
  // --- SHIFT MASTER ACTIONS ---
  const getShifts = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(`${BASE_URL}shifts/`);
      const payloadData = response.data.results ? response.data.results : response.data;
      dispatch({ type: "GET_SHIFTS_SUCCESS", payload: payloadData });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      dispatch({ type: "GET_SHIFTS_FAILURE", payload: { error: error } });
    }
  };

  const addShift = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.post(`${BASE_URL}shifts/`, reqData);
      dispatch({ type: "ADD_SHIFT_SUCCESS", payload: response.data });
      dispatch({ type: "LOADING", payload: false });
      dispatch(getShifts());
      return response.data;
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      dispatch({ type: "ADD_SHIFT_FAILURE", payload: { error: error } });
    }
  };

  const updateShift = (shiftId, reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.put(`${BASE_URL}shifts/${shiftId}/`, reqData);
      dispatch({ type: "UPDATE_SHIFT_SUCCESS", payload: response.data });
      dispatch({ type: "LOADING", payload: false });
      dispatch(getShifts());
      return response.data;
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      dispatch({ type: "UPDATE_SHIFT_FAILURE", payload: { error: error } });
    }
  };

  const deleteShift = (shiftId) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.delete(`${BASE_URL}shifts/${shiftId}/`);
      dispatch({ type: "DELETE_SHIFT_SUCCESS", payload: response.data });
      dispatch({ type: "LOADING", payload: false });
      dispatch(getShifts());
      return response.data;
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      dispatch({ type: "DELETE_SHIFT_FAILURE", payload: { error: error } });
    }
  };

  // --- EMPLOYEE SHIFT ASSIGNMENT ACTIONS ---
  const getEmployeeShifts = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(`${BASE_URL}employee-shifts/`);
      const payloadData = response.data.results ? response.data.results : response.data;
      dispatch({ type: "GET_EMPLOYEE_SHIFTS_SUCCESS", payload: payloadData });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      dispatch({ type: "GET_EMPLOYEE_SHIFTS_FAILURE", payload: { error: error } });
    }
  };

  const assignShift = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.post(`${BASE_URL}employee-shifts/`, reqData);
      dispatch({ type: "ASSIGN_SHIFT_SUCCESS", payload: response.data });
      dispatch({ type: "LOADING", payload: false });
      dispatch(getEmployeeShifts());
      return response.data;
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      dispatch({ type: "ASSIGN_SHIFT_FAILURE", payload: { error: error } });
    }
  };

  const updateAssignedShift = (assignmentId, reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.put(`${BASE_URL}employee-shifts/${assignmentId}/`, reqData);
      dispatch({ type: "UPDATE_ASSIGNED_SHIFT_SUCCESS", payload: response.data });
      dispatch({ type: "LOADING", payload: false });
      dispatch(getEmployeeShifts());
      return response.data;
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      dispatch({ type: "UPDATE_ASSIGNED_SHIFT_FAILURE", payload: { error: error } });
    }
  };

  const deleteAssignedShift = (assignmentId) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.delete(`${BASE_URL}employee-shifts/${assignmentId}/`);
      dispatch({ type: "DELETE_ASSIGNED_SHIFT_SUCCESS", payload: response.data });
      dispatch({ type: "LOADING", payload: false });
      dispatch(getEmployeeShifts());
      return response.data;
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      dispatch({ type: "DELETE_ASSIGNED_SHIFT_FAILURE", payload: { error: error } });
    }
  };

  return {
    getShifts,
    addShift,
    updateShift,
    deleteShift,
    getEmployeeShifts,
    assignShift,
    updateAssignedShift,
    deleteAssignedShift,
  };
};

export default ShiftApiViewController;
